import { Box, CircularProgress } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';
import { lazy, Suspense } from 'react';

const Highlights = lazy(() => import('pages/highlights'));

const Loader = (): JSX.Element => (
  <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
    <CircularProgress />
  </Box>
);

export const Route = createFileRoute('/_public/_empty/highlights')({
  component: HighlightsWrapper,
});

function HighlightsWrapper(): JSX.Element {
  return (
    <Suspense fallback={<Loader />}>
      <Highlights />
    </Suspense>
  );
}
